import React, { useState } from "react"
import styles from "./WIP.module.scss"

const WIP: React.FC = () => {
    const [loaded, setLoaded] = useState(false)
    return (
        <div className={styles.WIP}>
            {/* <h2>
                Please visit the <a href="https://app.pretzel.space">Pretzel Legacy app</a> to see
                full features.
            </h2> */}
            {!loaded && (
                <div className={styles.load}>
                    <div className="loader"></div>
                    <h2>Loading Legacy Pretzel...</h2>
                </div>
            )}
            <iframe
                src="https://app.pretzel.space"
                title="ok"
                onLoad={() => setLoaded(true)}
                style={{
                    position: "relative",
                    zIndex: 0,
                    width: "100%",
                    marginLeft: "-175px",
                    height: "100%",
                    border: 0,
                }}></iframe>
        </div>
    )
}

export default WIP
